'use client';
import PropTypes from 'prop-types';
import { interpolate } from '@format/interpolate';
import { useShopifyOfferContext } from '../../../offer/shopifyContext';
import { SlideoutMenuLink } from '../../SlideoutMenuLink';
import { SlideDownMenuLink } from '../../SlideDownMenuLink';
import { ReferAFriendLink, HeaderLink } from '../HeaderLink';
import {
  StyledNavLinkGroup,
  NavLinkGroupHeading,
  NavigationMenuLink,
} from './styles';

export const NavLinkGroup = ({
  heading,
  links,
  closeMenu,
  menuBgColor,
  linkFontColor = 'text.lightest',
  headingFontColor = 'text.lightest',
  index,
}) => {
  const { formattedAmount } = useShopifyOfferContext();

  return (
    <StyledNavLinkGroup $index={Number(index)}>
      <NavLinkGroupHeading $fontColor={headingFontColor}>
        {interpolate(heading, { offer: formattedAmount })}
      </NavLinkGroupHeading>
      {links?.map((link, index) => {
        const { component } = link;
        if (component === 'slideout_menu_link')
          return (
            <NavigationMenuLink
              key={link.component + index}
              $fontColor={linkFontColor}
            >
              <SlideoutMenuLink
                {...link}
                linkText={interpolate(link.text, { offer: formattedAmount })}
                key={index}
                onCloseMenu={closeMenu}
              />
            </NavigationMenuLink>
          );
        if (component === 'slide_down_menu_link')
          return (
            <NavigationMenuLink
              key={link.component + index}
              $fontColor={linkFontColor}
            >
              <SlideDownMenuLink
                {...link}
                linkText={interpolate(link.text, { offer: formattedAmount })}
                key={index}
                onCloseMenu={closeMenu}
                menuBgColor={menuBgColor}
              />
            </NavigationMenuLink>
          );
        if (component === 'refer_a_friend_button')
          return (
            <NavigationMenuLink
              key={link.component + index}
              $fontColor={linkFontColor}
            >
              <ReferAFriendLink
                key={index}
                position={index}
                {...link}
                type={'mobile'}
              />
            </NavigationMenuLink>
          );
        return (
          <NavigationMenuLink
            key={link.component + index}
            $fontColor={linkFontColor}
          >
            <HeaderLink
              target={link.target}
              position={index}
              text={interpolate(link.text, { offer: formattedAmount })}
              type="desktop"
              key={index}
              onClick={closeMenu}
            />
          </NavigationMenuLink>
        );
      })}
    </StyledNavLinkGroup>
  );
};

NavLinkGroup.displayName = 'MarketingMenuLinks';

NavLinkGroup.propTypes = {
  heading: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      target: PropTypes.string,
      text: PropTypes.string,
      component: PropTypes.string,
    }),
  ),
  closeMenu: PropTypes.func.isRequired,
  menuBgColor: PropTypes.string,
  linkFontColor: PropTypes.string,
  headingFontColor: PropTypes.string,
  index: PropTypes.number,
};
